const baseURL = process.env.REACT_APP_BASE_URL_MEDIA;
// const baseURL = 'http://34.239.222.93:1337/media/'; // production

export default baseURL;